module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/report_dummy_03-4a1b45e911cb61e25533bdd49480839f.jpg";